<template>
  <router-btn v-if="!SupplierReadonly" :text="$t('servicesystem.common_objects.commonterms.new')" :icon="'mdi-plus'"
    :color="'quaternary'" :disabled="false" :outlined="false" :textbtn="textbtn" :large="large" :small="small"
    @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NewSupplierBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      this.$router.push({ name: 'NewSupplier', params: { supplierId: 0 } });
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>
